import { render, staticRenderFns } from "./DimensionalColumnChart.vue?vue&type=template&id=4bdc2cfc&scoped=true&"
import script from "./DimensionalColumnChart.vue?vue&type=script&lang=js&"
export * from "./DimensionalColumnChart.vue?vue&type=script&lang=js&"
import style0 from "./DimensionalColumnChart.vue?vue&type=style&index=0&id=4bdc2cfc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc2cfc",
  null
  
)

export default component.exports